<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button class="button_icon button_icon_color" *ngIf="isRefresh" style="height:auto;" (click)="onRefreshTrigger()">replay_circle_filled</button>
  <button class="button_icon button_icon_color popup_close" *ngIf="isPopup" style="transform: rotate(45deg);color: palevioletred !important;font-size: 25px;" (click)="onClose()" title="{{localService.languageContent.common.close}}">add_circle_outline</button>
</div>
